/**
 * Calendar "what am I missing" pref.
 *
 * Pro trainers get a per-event list of the event's Pokémon they are still
 * missing from their Dex, rendered under each event card. The Calendar carries
 * a single toggle at the very top that shows/hides those lists everywhere on the
 * page, and this module persists that choice so it survives a reload and a
 * relaunch.
 *
 * Defaults ON: a Pro trainer who has paid for the cross-reference should see it
 * without hunting for a switch. Mirrors customDexLinkagePref.
 */

const STORAGE_KEY = "nexus.eventDexGaps.v1";

export const EVENT_DEX_GAPS_EVENT = "nexus:event-dex-gaps-changed";

let cache: boolean | null = null;

function loadFromStorage(): boolean {
  if (cache !== null) return cache;
  if (typeof window === "undefined") {
    cache = true;
    return cache;
  }
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    // Default ON: a missing key means the trainer has never set the pref.
    cache = raw === null ? true : raw === "true";
    return cache;
  } catch {
    cache = true;
    return cache;
  }
}

function emit(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(EVENT_DEX_GAPS_EVENT));
}

/** Whether the per-event "still missing" lists are shown. */
export function isEventDexGapsEnabled(): boolean {
  return loadFromStorage();
}

export function setEventDexGapsEnabled(enabled: boolean): void {
  cache = enabled;
  if (typeof window !== "undefined") {
    try {
      window.localStorage.setItem(STORAGE_KEY, enabled ? "true" : "false");
    } catch {
      // ignore quota errors — the in-memory cache keeps this session consistent
    }
  }
  emit();
}

/** Test-only helper: reset the in-memory cache. */
export function __resetEventDexGapsCacheForTests(): void {
  cache = null;
}
